import React, { Suspense, ReactNode } from 'react';
import { Loader2 } from 'lucide-react';

interface SafeSuspenseProps {
  children: ReactNode;
  fallback?: ReactNode;
}

/**
 * Enterprise SafeSuspense.
 * Standardizes lazy-loaded page load animations to prevent layout flickering.
 */
export const SafeSuspense: React.FC<SafeSuspenseProps> = ({ children, fallback }) => {
  const defaultFallback = (
    <div className="w-full min-h-[140px] flex flex-col items-center justify-center p-8 space-y-3">
      <Loader2 className="w-6 h-6 animate-spin text-slate-400 dark:text-slate-600" />
      <span className="text-[10px] font-bold text-slate-400 dark:text-slate-600 uppercase tracking-widest animate-pulse">
        Carregando módulo...
      </span>
    </div>
  );

  return (
    <Suspense fallback={fallback || defaultFallback}>
      {children}
    </Suspense>
  );
};

export default SafeSuspense;
